export const URL_TYPES = {
    old: 'Старый URL',
    new: 'Новый URL',
};

export const LIST_PAGE_URL = '/contentmanager/canonical/all';
